import { render } from "./c-avatar.vue?vue&type=template&id=4c1089a7&scoped=true"
import script from "./c-avatar.vue?vue&type=script&lang=js"
export * from "./c-avatar.vue?vue&type=script&lang=js"

import "./c-avatar.vue?vue&type=style&index=0&id=4c1089a7&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1089a7"]])

export default __exports__